import { Injectable, Injector } from '@angular/core';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { AuthenticationService } from './core/authentication/authentication.service';
import { HttpClient } from '@angular/common/http';
import { Logger } from './core';
import { Identifiers } from '@shared/services/app.config.type';

@Injectable()
export class MyStartupService {
  public data: any;
  private authService!: AuthenticationService;
  private http!: any;

  constructor(private injector: Injector) {
    if (this.authService === undefined) {
      this.authService = this.injector.get(AuthenticationService);
    }
    if (this.http === undefined) {
      this.http = this.injector.get(HttpClient);
    }
    const fire = this.http['appConfig'].getConfig(Identifiers.FrontendLogger, 'fire');
    Logger.fire = fire;
    Logger.httpClient = this.http;
    Logger.authService = this.authService;
  }

  async load() {
    return new Promise((resolve, reject) => {
      resolve(1);
    });
  }
}
